import { getMaterialPullAdvertisers, addMaterialPullAdvertiser, getMaterialPullRecords, createMaterialPullTask, getMaterialPullProgress } from '@/api/material-pull'
import infiniteScroll from '@/components/video-select/Scroll'
import moment from 'moment'

export default {
    directives: { infiniteScroll },
    model: {
        prop: 'ids',
        event: 'change'
    },
    props: {
        ids: {
            type: Array,
            default: () => []
        },
        maxNum: {
            type: Number,
            default: 30
        },
        media: {
            type: String,
            default: 'juliang'
        }
    },
    data() {
        return {
            show: false,
            loading: false,
            finished: false,
            busy: false,
            videos: [],
            currentIds: [],
            page: 1,
            queryParam: {
                advertiser_id: undefined,
                name: '',
                create_time_start: null,
                create_time_end: null,
            },
            advertiserList: [],
            pullModalVisible: false,
            pullForm: {
                advertiser_id: '',
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
            },
            pullLoading: false,
            progressList: [],
            progressTimer: null,
            currentVideo: null,
            dateRange: null,
        }
    },
    watch: {
        show(value) {
            if (!value) {
                this.videos = []
                this.finished = false
                this.page = 1
                this.stopProgressPolling()
                return
            }
            this.loadAdvertisers()
            this.getData()
            this.startProgressPolling()
        },
        ids: {
            handler(val) {
                this.currentIds = Object.assign([], val)
            },
            immediate: true
        }
    },
    beforeDestroy() {
        this.stopProgressPolling()
    },
    methods: {
        loadAdvertisers() {
            getMaterialPullAdvertisers().then(res => {
                this.advertiserList = res.data.list || res.data || []
            })
        },
        handleInfiniteOnLoad() {
            if (this.finished || this.loading) return
            this.getData()
        },
        getData() {
            const json = {
                page: this.page,
                page_size: 100,
                advertiser_id: this.queryParam.advertiser_id || undefined,
                name: this.queryParam.name || undefined,
                create_time_start: this.queryParam.create_time_start || undefined,
                create_time_end: this.queryParam.create_time_end || undefined,
            }
            this.loading = true
            getMaterialPullRecords(json).then(res => {
                this.page++
                this.loading = false
                const list = res.data.list || []
                if (list.length === 0) {
                    this.finished = true
                }
                this.videos = this.videos.concat(list)
            }).finally(() => {
                this.loading = false
            })
        },
        search() {
            this.videos = []
            this.page = 1
            this.finished = false
            this.getData()
        },
        resetSearch() {
            this.queryParam = {
                advertiser_id: undefined,
                name: '',
                create_time_start: null,
                create_time_end: null,
            }
            this.dateRange = null
            this.search()
        },
        onDateRangeChange(dates) {
            if (dates && dates.length === 2) {
                this.queryParam.create_time_start = dates[0]
                this.queryParam.create_time_end = dates[1]
            } else {
                this.queryParam.create_time_start = null
                this.queryParam.create_time_end = null
            }
        },
        filterAdvertiserOption(input, option) {
            const text = option.componentOptions.children[0].text || ''
            const value = option.componentOptions.propsData.value || ''
            const search = input.toLowerCase()
            return text.toLowerCase().includes(search) || value.toLowerCase().includes(search)
        },
        changeVideoId(video) {
            for (const key in this.currentIds) {
                if (this.currentIds[key].material_id === video.material_id) {
                    delete this.currentIds[key]
                    this.currentIds = this.currentIds.filter(v => v !== null)
                    return true
                }
            }
            if (this.currentIds.length >= this.maxNum) {
                return this.$message.error(`当前最多支持选择${this.maxNum}个视频`)
            }

            if (!video.width || !video.height) return
            const ratio = video.width / video.height
            const ratioRounded = Number(ratio.toFixed(4))
            if (ratioRounded !== 0.5625 && ratioRounded !== 1.7778) return

            this.currentIds.push(video)
        },
        videoSelected(video) {
            return this.currentIds.some(item => item.material_id === video.material_id)
        },
        clearSelected() {
            this.currentIds = []
            this.complete()
        },
        preview(video) {
            this.currentVideo = video
        },
        hidePreview() {
            this.currentVideo = null
        },
        close() {
            this.show = false
            this.currentIds = Object.assign([], this.ids)
        },
        complete() {
            this.$emit('change', Object.assign([], this.currentIds))
            this.show = false
        },
        selectAll() {
            for (const video of this.videos) {
                if (this.currentIds.length >= this.maxNum) break
                if (!this.videoSelected(video)) {
                    if (video.width && video.height) {
                        const ratio = video.width / video.height
                        const ratioRounded = Number(ratio.toFixed(4))
                        if (ratioRounded === 0.5625 || ratioRounded === 1.7778) {
                            this.currentIds.push(video)
                        }
                    }
                }
            }
        },
        showPullModal() {
            this.pullForm.advertiser_id = this.queryParam.advertiser_id || ''
            this.pullForm.start_date = moment().format('YYYY-MM-DD')
            this.pullForm.end_date = moment().format('YYYY-MM-DD')
            this.pullModalVisible = true
        },
        handlePull() {
            if (!this.pullForm.advertiser_id) {
                return this.$message.error('请输入广告主ID')
            }
            const start = moment(this.pullForm.start_date)
            const end = moment(this.pullForm.end_date)
            if (end.diff(start, 'days') > 2) {
                return this.$message.error('最大拉取3天数据')
            }

            this.pullLoading = true
            const exists = this.advertiserList.find(a => a.advertiser_id === this.pullForm.advertiser_id)

            const doCreateTask = () => {
                createMaterialPullTask({
                    advertiser_id: this.pullForm.advertiser_id,
                    start_date: this.pullForm.start_date,
                    end_date: this.pullForm.end_date,
                }).then(() => {
                    this.$message.success('拉取任务已创建，请等待拉取完成')
                    this.pullModalVisible = false
                    this.startProgressPolling()
                }).finally(() => {
                    this.pullLoading = false
                })
            }

            if (!exists) {
                addMaterialPullAdvertiser({ advertiser_id: this.pullForm.advertiser_id }).then(() => {
                    this.loadAdvertisers()
                    doCreateTask()
                }).catch(() => {
                    this.pullLoading = false
                })
            } else {
                doCreateTask()
            }
        },
        startProgressPolling() {
            this.stopProgressPolling()
            this.fetchProgress()
            this.progressTimer = setInterval(() => {
                this.fetchProgress()
            }, 3000)
        },
        stopProgressPolling() {
            if (this.progressTimer) {
                clearInterval(this.progressTimer)
                this.progressTimer = null
            }
        },
        fetchProgress() {
            getMaterialPullProgress().then(res => {
                this.progressList = res.data.list || res.data || []
                // const hasActive = this.progressList.some(t => t.status === 0 || t.status === 1)
                // if (!hasActive && this.progressList.length > 0) {
                //     this.search()
                // }
            })
        },
    }
}
